import { request } from '@blade/common';
import { useLocal } from '.';
import { LibStatusEnum, PageOrderEnum } from '@blade-sxp/portrait-management/interfaces/common';
import { dateFormat } from '@blade/common/utils/filters';
let list = [];
for (let i = 0; i < 20; i++) {
    if (useLocal)
        addPortraitLib({ name: ` Portrait Library Name Too Long asdasda asd asd 阿松大  123124ss ${i}` });
}
export function updatePortraitLib(data) {
    if (!useLocal) {
        return request({
            url: `/api/portrait-management/api/v1/portraitlib/${data.libId}`,
            method: 'PUT',
            data,
        });
    }
    return new Promise((resolve) => {
        const result = list.find(p => p.libId === data.libId);
        if (result)
            result.name = data.name;
        setTimeout(() => {
            resolve(result);
        }, 200);
    });
}
export function addPortraitLib(data) {
    if (!useLocal) {
        return request({
            url: '/api/portrait-management/api/v1/portraitlib/add',
            method: 'POST',
            data,
        });
    }
    return new Promise((resolve) => {
        const result = {
            ...data,
            libId: Math.random() * 100000000,
            libType: 'x',
            status: LibStatusEnum.ENABLE,
            businessScene: 'x',
            groupType: 'x',
            synGroupId: 'x',
            portraitNumber: 1,
            rsmId: 'x',
            updateAt: dateFormat(new Date(), 'yyyy-MM-DD HH:mm:ss') ?? '',
            createBy: 'lrf',
            platformLibId: 'x'
        };
        list.push(result);
        setTimeout(() => {
            resolve(result);
        }, 200);
    });
}
export function queryPortraitLibPageList(data) {
    if (!useLocal) {
        return request({
            url: '/api/portrait-management/api/v1/portraitlib/page/query',
            method: 'POST',
            data,
        });
    }
    return new Promise((resolve) => {
        // 先过滤
        let tmp = list.filter(a => !data.keywords || a.name.includes(data.keywords));
        if (data.status)
            tmp = tmp.filter(a => a.status === data.status);
        // 再排序
        if (data.pageOrderList) {
            for (const orderList of data.pageOrderList) {
                if (orderList.orderField === 'updateAt') {
                    tmp = tmp.sort((a, b) => {
                        if (orderList.orderType === PageOrderEnum.ASC)
                            return +new Date(a.updateAt) - +new Date(b.updateAt);
                        return +new Date(b.updateAt) - +new Date(a.updateAt);
                    });
                }
            }
        }
        // 再分页
        const page = data.page ?? 1;
        const size = data.size ?? 10;
        const result = {
            page,
            size,
            total: tmp.length,
            totalPage: parseInt(tmp.length / size + '') + tmp.length % size > 0 ? 1 : 0,
            list: tmp.slice((page - 1) * size, page * size),
            empty: false
        };
        setTimeout(() => {
            resolve(result);
        }, 200);
    });
}
export function enablePortraitLib(libId) {
    if (!useLocal) {
        return request({
            url: `/api/portrait-management/api/v1/portraitlib/enable/${libId}`,
            method: 'PUT',
        });
    }
    return new Promise((resolve) => {
        const result = list.find(p => p.libId === libId);
        if (result)
            result.status = LibStatusEnum.ENABLE;
        setTimeout(() => {
            resolve(result);
        }, 200);
    });
}
export function disablePortraitLib(libId) {
    if (!useLocal) {
        return request({
            url: `/api/portrait-management/api/v1/portraitlib/disable/${libId}`,
            method: 'PUT',
        });
    }
    return new Promise((resolve) => {
        const result = list.find(p => p.libId === libId);
        if (result)
            result.status = LibStatusEnum.DISABLE;
        setTimeout(() => {
            resolve(result);
        }, 200);
    });
}
export function deletePortraitLib(libId) {
    if (!useLocal) {
        return request({
            url: `/api/portrait-management/api/v1/portraitlib/${libId}`,
            method: 'DELETE',
        });
    }
    return new Promise((resolve) => {
        list = list.filter(p => p.libId !== libId);
        setTimeout(() => {
            resolve(null);
        }, 200);
    });
}
export async function getPortraitLibAll(data) {
    if (!useLocal) {
        const result = await request({
            url: `/api/portrait-management/api/v1/portraitlib/list`,
            method: 'POST',
            data: data ?? {}
        });
        return result.list;
    }
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(list);
        }, 200);
    });
}
